export const hasMenuPermission = (userPermissions = [], permission) => {

  if (!permission) return true;

  if (typeof permission === "string") {
    return userPermissions.includes(permission);
  }

  if (Array.isArray(permission)) {
    return permission.some((p) => userPermissions.includes(p));
  }

  return false;
};